module.exports = __webpack_public_path__ + "img/logs.700f3642.svg";